import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { constructNow, isAfter, addDays } from 'date-fns';
import Close from '../../assets/images/pool_event/cross-black.png';

export default function PoolEventPrize({ rank, prize }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const closePopup = (days) => {
    setIsOpen(false);
    localStorage.setItem('poolEventPrize', addDays(constructNow(), days));
  };

  useEffect(() => {
    const lastClose = localStorage.getItem('poolEventPrize');
    if (!lastClose || isAfter(constructNow(), lastClose)) {
      setIsOpen(true);
    }
  }, []);

  // 상품 이미지 번호 매핑
  const prizeNo = useMemo(() => {
    if (rank === 0) return 0;
    if (rank === 1) return 1;
    if (rank === 2 || rank === 3) return 2;
    if (rank === 4 || rank === 5) return 3;
    if (rank === 6 || rank === 7) return 4;
    if (rank >= 8 && rank <= 11) return 5;
    if (rank >= 12) return 7;
  }, [rank]);

  return (
    <div className={`${isOpen ? 'pool-event-popup' : 'popup-hide'}`}>
      <div className="pool-event-prize-container">
        <div className="pool-event-prize-contents">
          <img
            className="prize-popup-close"
            src={Close}
            width={14}
            height={14}
            alt="닫기"
            onClick={() => closePopup(1)}
          />
          <div className="prize-popup-title">
            {prizeNo === 0 ? '아쉽게 이번 주에는 당첨되지 않았어요.' : '당첨 축하 합니다 !!'}
            {prizeNo === 0 && <p>다음주에 도전해 주세요!</p>}
          </div>
          <div className="prize-popup-name">{prize}</div>
          <img
            className={`prize-image ${prizeNo === 0 ? 'prize-image-empty' : ''}`}
            src={`/pool-event/prize-0${prizeNo}.png`}
            alt="수영장 이벤트 상품"
          />
          {prizeNo !== 0 && (
            <div className="prize-popup-info">
              <p>상품은 송추 히든밸리 수영장에서 교환 부탁드립니다.</p>
              <p>이 선물은 수영장 고객 전용 혜택이예요!</p>
            </div>
          )}
          <div
            className="prize-popup-button"
            onClick={() => {
              closePopup(1);
              if (prizeNo >= 1 && prizeNo <= 5) {
                navigate('/user/coupons');
              } else if (prizeNo === 7) {
                navigate('/user/points');
              }
            }}
          >
            {prizeNo >= 1 && prizeNo <= 5 && '쿠폰함 가기'}
            {prizeNo === 7 && '포인트 내역 가기'}
            {prizeNo === 0 && '확 인'}
          </div>
        </div>
      </div>
    </div>
  );
}
